import React from 'react';

import { PipsSlider } from '@/components/PipsSlider/PipsSlider';
import {
  calcMaxDepositPercentage,
  calcMinDepositPercentage,
} from '@/lib/payment/v12';

import { createPercentageMarks } from './helper';

interface DepositSliderProps {
  amount: number;
  maxLoan: number;
  minLoan: number;
  onChange: (v: number) => void;
  value: number;
}

export const DepositSlider = ({
  amount,
  maxLoan,
  minLoan,
  onChange,
  value,
}: DepositSliderProps) => {
  const minDepositPercentage = calcMinDepositPercentage(amount, maxLoan);
  const maxDepositPercentage = calcMaxDepositPercentage(amount, minLoan);

  if (minDepositPercentage === null || maxDepositPercentage === null) {
    return null;
  }

  const { markLabels, marks } = createPercentageMarks(
    minDepositPercentage,
    maxDepositPercentage,
  );

  return (
    <PipsSlider
      className='deposit-slider'
      markLabels={markLabels}
      marks={marks}
      max={maxDepositPercentage}
      min={minDepositPercentage}
      onChange={onChange}
      value={value}
    />
  );
};
